import { useState, useEffect, useCallback, useRef } from 'react';

const useInfiniteScroll = (handleFetchMore, hasMore) => {
  const [showScroll, setShowScroll] = useState(false);
  const containerRef = useRef(null);

  const handleScroll = useCallback(() => {
    if (!containerRef.current) return;

    const { scrollTop, scrollHeight, clientHeight } = containerRef.current;

    // Infinite Scroll: Load more content when near the bottom
    if (hasMore && scrollTop + clientHeight >= scrollHeight - 20) {
      handleFetchMore();
    }

    // Show/Hide Scroll to Top button
    if (scrollTop > 300 && !showScroll) setShowScroll(true);
    if (scrollTop <= 300 && showScroll) setShowScroll(false);
  }, [handleFetchMore, hasMore, showScroll]);

  useEffect(() => {
    const container = containerRef.current;

    if (!container) return undefined;

    container.addEventListener('scroll', handleScroll);
    return () => container.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  const scrollToTop = () => {
    containerRef.current?.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return { containerRef, showScroll, scrollToTop };
};

export default useInfiniteScroll;
